module.exports = __webpack_public_path__ + "img/flutter-white.c36127e2.png";